import DmarcStatusToken from '@admin/tokens/dmarc_status'
import Panel from '@admin/components/panel'

const mapPropsToPanel = (props, context) => ({
  title: 't(Records)',
  collection: {
    endpoint: `/api/admin/truevail/admin/deliverability/dmarc_reports/${props.dmarc_report.id}/records`,
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Header From)', key: 'header_from.name', sort: 'header_from' },
      { label: 't(Source IP)', key: 'source_ip.ipv4', sort: 'source_ip' },
      { label: 't(Count)', key: 'count', collapsing: true, align: 'right' },
      { label: 't(Disposition)', key: 'disposition', collapsing: true, sort: 'domain', format: DmarcStatusToken },
      { label: 't(SPF)', key: 'spf', collapsing: true, format: DmarcStatusToken },
      { label: 't(DKIM)', key: 'dkim', collapsing: true, format: DmarcStatusToken }
    ],
    defaultSort: { key: 'header_from', order: 'asc' },
    empty: {
      svg: 'x',
      title: 't(No DMARC Records)',
      text: 't(There are no DMARC records)'
    },
    entity: 'records'
  }
})

export default Panel(null, mapPropsToPanel)
